import React from "react";
import { Link } from "react-router-dom";
import { StaticPage, Section } from "../components/StaticPage";

export const About = () => (
  <StaticPage
    title="About Us"
    subtitle="Welcome to Absolute Cinema."
    testId="about-page"
  >
    <p>
      Absolute Cinema is a cinema-focused entertainment website created for people who enjoy
      movies, cinema, entertainment, and interactive experiences.
    </p>
    <p>
      Our website provides visitors with an easy-to-use online experience that may include
      cinema-related content, interactive features, games, audio features, and other
      entertainment-related features.
    </p>
    <p>
      Our goal is to create a simple, accessible, and enjoyable destination for visitors
      interested in cinema and entertainment.
    </p>

    <Section heading="Our Approach">
      <p>
        We aim to provide an engaging experience for our visitors while continuously improving
        the website's functionality, performance, usability, and overall experience.
      </p>
      <p>We also aim to present information and features in a clear and straightforward manner.</p>
    </Section>

    <Section heading="Third-Party Content and Intellectual Property">
      <p>
        Absolute Cinema respects the intellectual-property rights of content creators, artists,
        copyright holders, studios, music labels, and other rights holders.
      </p>
      <p>
        Any third-party movies, movie-related materials, audio, music, recordings, images,
        artwork, characters, logos, trademarks, screenshots, titles, or other intellectual
        property that may appear on, be referenced by, or be associated with Absolute Cinema
        belong to their respective owners.
      </p>
      <p>
        Absolute Cinema does not claim ownership of third-party copyrighted material or
        intellectual property.
      </p>
      <p>
        The appearance or reference of third-party names, titles, trademarks, artwork, audio,
        music, movies, characters, or other materials does not necessarily indicate sponsorship,
        endorsement, authorization, or official affiliation with the respective rights holder.
      </p>
      <p>
        Absolute Cinema is an independent website and does not claim to be officially affiliated
        with any movie studio, production company, music label, artist, actor, filmmaker, game
        publisher, or other rights holder unless explicitly stated.
      </p>
      <p>
        If you are a copyright or intellectual-property rights holder and have a concern regarding
        material associated with the website, please contact us through our{" "}
        <Link to="/contact" className="ac-gold-text hover:underline">Contact Us</Link> page.
      </p>
    </Section>

    <Section heading="Contact">
      <p>
        For questions, feedback, technical issues, privacy questions, or intellectual-property
        concerns, please visit our{" "}
        <Link to="/contact" className="ac-gold-text hover:underline">Contact Us</Link> page.
      </p>
    </Section>
  </StaticPage>
);
